/* unplugin-vue-components disabled */import { render } from "./exam-Writing.vue?vue&type=template&id=2b7bf456&scoped=true"
import script from "./exam-Writing.vue?vue&type=script&lang=js"
export * from "./exam-Writing.vue?vue&type=script&lang=js"

import "./exam-Writing.vue?vue&type=style&index=0&id=2b7bf456&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7bf456"]])

export default __exports__